import readStored from './readStored';

/**
 * Function to set the default value to filters and sorting at CustomersList mount and on change when no filters values are setted.
 * The function accepts an array of objects ({ 'sortValue', defaultValue}) and checks in localStorage if the 'sortValue' is present, otherwise it sets the value to default or null if not provided.
 * Returns an object with the provided 'sortValue's and their values.
 *
 * @param {Array} sortingKeys - Array. Each element must be an object with at least value property.
 *
 * @returns {Object} The sortValue object object.
 */

export default (sortingKeys = []) => {
  if (sortingKeys.length < 1) return {};

  const { value: savedSortValue, direction } = readStored('sortValue') ?? {};

  const sortOption =
    sortingKeys?.find(({ value }) => value === savedSortValue) ??
    sortingKeys?.find(({ isDefault }) => isDefault);

  return {
    sortValue: {
      ...sortOption,
      direction: direction ?? sortOption?.direction ?? 'asc', //option can set its own default direction
    },
  };
};
